import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Tips(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='tips-glance-body'
                cssHeadingClass='tips-glance-heading'
                cssIconClass='icons8-donate-coin'
                Heading={t('Tips')}
                DataPoint1={props.DP1}
                DataPoint3={props.DP2 + ' ' + t('Checks')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}